<template>
  <c-flex mr="-30px" ml="-30px" flexDirection="column">
    <c-flex
      height="330px"
      background="#4b4b4b"
      backgroundImage="url(/img/learning/header.png)"
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="base"
      overflow="hidden"
      mr="xl"
      v-chakra="{
        '@media (min-width: 2048px)': {
          mr: '0',
        },
      }"
      :mt="{ base: '3xl', sm: '3rem', md: '4xl' }"
      :ml="{ base: 'xl', xl: '2xl' }"
      :justifyContent="{ base: 'center', sm: 'flex-start' }"
      maxWidth="100%"
    >
      <c-box
        maxWidth="100%"
        width="md"
        :pl="{ base: '3xl', sm: '4xl' }"
        :pt="{ base: '3xl', sm: '4xl' }"
        :pr="{ base: '3xl', sm: '4xl' }"
        :pb="{ base: '3xl', sm: '4xl' }"
      >
        <CHeading line-height="3.5rem" color="white" as="h1">{{
          $t("learning.header.headerText")
        }}</CHeading>
        <c-text color="white">{{ $t("learning.header.content") }}</c-text>
      </c-box>
    </c-flex>

    <c-flex maxWidth="100%" justifyContent="center" :ml="{ md: 'xl' }" :mr="{ md: 'xl' }">
      <c-flex
        mt="3xl"
        mb="xl"
        :maxWidth="{ base: '90%', lg: '70%' }"
        alignItems="center"
        flexDirection="column"
        justifyContent="space-between"
        background="white"
        :padding="{ base: '22px 33px 33px', md: '33px 44px 40px', lg: '33px 86px 40px' }"
        borderRadius="base"
        boxShadow="base"
      >
        <c-box mt="xl" mb="xl">
          <p
            v-html="
              showAcademy
                ? $t('learning.linkBox.spceContent')
                : $t('learning.linkBox.spceDisabledContent')
            "
          ></p>
        </c-box>
        <c-link :href="showAcademy ? linkUrl : ''" target="iLOQ Academy">
          <c-button
            variation="solid"
            background="brand.beige"
            borderWidth="0"
            :disabled="!showAcademy"
            color="black"
            :ml="{ md: 'md' }"
            :mr="{ base: 'auto', md: '0' }"
          >
            {{
              showAcademy
                ? $t("learning.linkBox.buttonText")
                : $t("learning.linkBox.disabledButtonText")
            }}
          </c-button>
        </c-link>
      </c-flex>
    </c-flex>
    <c-box>
      <c-text
        color="brand.grayDark"
        fontWeight="300"
        m="xl"
        mb="0"
        maxWidth="100%"
        textAlign="center"
        >{{ $t("learning.disclaimer") }}</c-text
      >
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import config from "@/config";
import Button from "@/design-system/elements/Button.vue";
import { CBox, CButton, CFlex, CHeading, CLink, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { IRootState } from "@iloq/shared";

export default defineComponent({
  name: "Academy",
  components: {
    Button,
    CHeading,
    CText,
    CBox,
    CFlex,
    CButton,
    CLink,
  },
  computed: {
    ...mapState({
      user: (state: unknown) => (state as IRootState).user!,
    }),
    linkUrl(): any {
      const domain = this.user.email.split("@")[1]; //Domain is used as an account hint for SP_CE
      return config.get("academyUrl") + domain;
    },
    showAcademy(): boolean {
      const academyEnabledCountryList: string[] = config.get("academyEnabledCountryList");
      return (
        academyEnabledCountryList.includes(this.user.countryCode) &&
        !this.user.groups.includes("Country_OTHER") // Avoid hiding the academy for users in the "COUNTRY_OTHER" group mapped to countryCode "US"
      );
    },
  },
});
</script>
